module.exports = __webpack_public_path__ + "static/giletPrimoFrontLogo-1a8f431873d15f9b2f847687eeb3f003.jpg";